import {composeReducers, createReducerFunction} from 'immer-reducer'
import defaultState from 'redux/diagnostics/state'
import Diagnostics from 'redux/diagnostics/diagnostics.duck'

export default composeReducers(
  createReducerFunction(Diagnostics, defaultState)
)
